import _toConsumableArray from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _defineProperty from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";

/*! Provides core utilities for the working with both versions of the ESRI JSAPI.
 *
 * @ai360/core v35.6.1 (https://bitbucket.org/agvanceskyteam/ai360.client.core.git)
 * SSI DO NOT COPY!!!
 */
import { _ as t, b as e } from "../tslib.es6.js";
import * as i from "@arcgis/core/geometry/geometryEngine";
import s from "@arcgis/core/geometry/Circle";
import o from "@arcgis/core/Graphic";
import n from "@arcgis/core/geometry/Point";
import { ay as a, az as r, aA as l } from "../api/rec.js";
import "uuid";
import "@arcgis/core/geometry/SpatialReference";
import "@arcgis/core/tasks/Locator";
import "@arcgis/core/geometry/support/webMercatorUtils";
import "@arcgis/core/geometry/support/jsonUtils";
import "@arcgis/core/geometry/projection";
import "@terraformer/arcgis";
import { T as h, n as c } from "../index.js";
import "lodash";
import { c as d, C as u, T as m, G as y, d as p } from "../enums.js";
import { A as g } from "../utils/auto-pan.js";
import { G as f } from "../geometry/creator.js";
import { G as A, b as v } from "../geometry/utils.js";
import { L as Z } from "../label-manager.js";
import { S as b, J as L } from "../symbols.js";
import { Z as I } from "../utils/zone.js";
import { Z as E } from "../zone-tools-base.js";

var S, T, P, R, G, D, _, C, w, z, F, N, M, O, U, V, B, W, J, j, k, x, H, Y;

var q = "AREA_ID",
    X = _objectSpread({}, a);

var ScoutingZoneTools = /*#__PURE__*/function (_E) {
  _inherits(ScoutingZoneTools, _E);

  var _super = _createSuper(ScoutingZoneTools);

  function ScoutingZoneTools(e, i) {
    var _this;

    _classCallCheck(this, ScoutingZoneTools);

    _this = _super.call(this, e, i), S.add(_assertThisInitialized(_this)), T.set(_assertThisInitialized(_this), void 0), _this.id = "scoutingZones", _this.activeLayer = _this.getLayer("ACTIVE_SCOUTING_ZONES_LAYER"), _this.activePointsLayer = _this.getLayer("ACTIVE_SCOUTING_POINT_ZONES_LAYER"), _this.dataLayer = _this.getLayer("SCOUTING_ZONES_DATA_LAYER"), _this.dataPointLayer = _this.getLayer("SCOUTING_ZONES_POINT_DATA_LAYER"), _this.drawLayer = _this.getLayer("SCOUTING_ZONES_DRAW_LAYER"), _this.activeLayer.graphics.on("before-add", function (t) {
      return t.item.symbol = b.fromJSON(h.symbols.zones.active.normal);
    }), _this.activePointsLayer.graphics.on("before-add", function (t) {
      return t.item.symbol = b.fromJSON(h.symbols.zones.scoutingPoint.active);
    }), _this.dataPointLayer.graphics.on("before-add", function (t) {
      return t.item.symbol = b.fromJSON(h.symbols.zones.scoutingPoint.normal);
    }), _this.polygonCreator = new f(_this.mapView, {
      drawLayer: _this.drawLayer,
      geometryType: d.POLYGON,
      invalidSymbol: b.fromJSON(h.symbols.zones.create.invalid),
      onDraw: function onDraw(e) {
        return t(_assertThisInitialized(_this), S, "m", V).call(_assertThisInitialized(_this), e, d.POLYGON);
      },
      symbol: b.fromJSON(h.symbols.zones.create.fill)
    }), _this.pointCreator = new f(_this.mapView, {
      drawLayer: _this.drawLayer,
      geometryType: d.POINT,
      onDraw: function onDraw(e) {
        return t(_assertThisInitialized(_this), S, "m", V).call(_assertThisInitialized(_this), e, d.POINT);
      },
      symbol: b.fromJSON(h.symbols.zones.scoutingPoint.normal)
    }), _this.polygonCreator.history.on("state-added", function () {
      return _this.forceUpdate();
    }), _this.pointCreator.history.on("state-added", function () {
      return _this.forceUpdate();
    }), _this.labelManager = new Z(_this.drawLayer), _this.autoPan = new g(_this.mapView);
    return _this;
  }

  _createClass(ScoutingZoneTools, [{
    key: "activateTool",
    value: function activateTool(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;

      switch (null == t && this.unSelectTools(!0, i), t) {
        case m.ScoutingZoneCreate:
          this.mapView.container.style.cursor = u.crosshair, this.polygonCreator.activate();
          break;

        case m.ScoutingPointZoneCreate:
          this.mapView.container.style.cursor = u.pointer, this.pointCreator.activate();
          break;

        default:
          this.mapView.container.style.cursor = u.default;
      }

      i && this.forceUpdate();
    }
  }, {
    key: "activateZone",
    value: function activateZone(e) {
      var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      this.clearActiveZone(), this.activeZone = e ? e.clone() : null;

      if (this.activeZone) {
        var _e = this.activeZone.attributes.AREA_ID;
        this.activeZoneHistory.setState(_e), i && (t(this, S, "m", j).call(this), this.forceUpdate()), this.options.onSetActiveZone(this.field.fieldGuid, _e);
      } else this.options.onSetActiveZone(this.field.fieldGuid, null);

      return [];
    }
  }, {
    key: "applyHistoryState",
    value: function applyHistoryState(t, e) {
      this.options.onRestoreAreaList(this.field.fieldGuid, this.getRestoreId(this.history.historyIndex), t), this.zones = t;
      var i = this.zones.find(function (t) {
        return t.attributes.AREA_ID === e;
      });
      this.activeZone = new o({
        geometry: i.geometry,
        attributes: i.attributes,
        symbol: b.fromJSON(h.symbols.zones.active.normal)
      }), this.options.onSetActiveZone(this.field.fieldGuid, e), this.resetGraphics(), this.forceUpdate();
    }
  }, {
    key: "callResetZones",
    value: function callResetZones(t) {
      var _this2 = this;

      this.field && this.options.onResetZones(this.field.fieldGuid, new Map(t.map(function (t) {
        return [t.attributes.AREA_ID, {
          shape: t.geometry,
          fieldBoundaryGuid: I.zoneIsWholeFieldZone(_this2.entireFieldZones, t) ? _this2.field.fieldBoundaryGuid : null
        }];
      })));
    }
  }, {
    key: "cancel",
    value: function cancel() {
      return this.field = null, this.fieldBoundaryGuid = null, this.entireFieldZones = [], this.recEventDetails = null, e(this, T, !0, "f"), this.clear();
    }
  }, {
    key: "canRedo",
    value: function canRedo() {
      return this.polygonCreator.isActive() ? this.polygonCreator.history.canRedo() || this.history.canRedo() : this.pointCreator.isActive() && this.pointCreator.history.canRedo() || this.history.canRedo();
    }
  }, {
    key: "canUndo",
    value: function canUndo() {
      return this.history.canUndo() || this.activeTool === m.ScoutingZoneCreate && this.polygonCreator.isActive() && this.polygonCreator.history.canUndo() || this.activeTool === m.ScoutingPointZoneCreate && this.pointCreator.isActive() && this.pointCreator.history.canUndo();
    }
  }, {
    key: "clearActiveZone",
    value: function clearActiveZone() {
      this.activeLayer.removeAll(), this.activePointsLayer.removeAll(), this.labelManager.clearLabel();
    }
  }, {
    key: "createMapListeners",
    value: function createMapListeners() {
      var _this3 = this;

      this.removeMapListeners(), this.mapListeners.add(this.mapView.on("pointer-down", function (t) {
        var e = _this3.mapView.toMap(t);

        _this3.activeTool || (_this3.zones.find(function (t) {
          return t.geometry.contains(e);
        }) ? _this3.preventDoubleClick = !0 : _this3.preventDoubleClick = !1, _this3.mouseDownScreenPnt = t);
      })), this.mapListeners.add(this.mapView.on("pointer-up", function (e) {
        var s = _this3.mapView.toMap(e),
            o = new n({
          x: e.x,
          y: e.y
        });

        if (!_this3.mouseDownScreenPnt || _this3.activeTool) return;
        var a = {
          include: [_this3.dataLayer, _this3.dataPointLayer, _this3.activeLayer, _this3.activePointsLayer, _this3.fieldsLayer.layer]
        };

        _this3.mapView.hitTest(e, a).then(function (e) {
          if (e.results.length) {
            var _n = e.results[0].graphic;
            if (_n && _n.geometry.type === y.point && !_n.attributes) return;
            if (_n && _n.layer == _this3.fieldsLayer.layer && _n.attributes.fieldBoundaryGuid !== _this3.fieldBoundaryGuid) return;
            var _a = _this3.mouseDownScreenPnt;
            _this3.mouseDownScreenPnt = null;
            var _r = null;
            if (A.arePointsWithinTolerance(_a, o, 2)) if (_n && _n.geometry.type === y.point) _r = _this3.zones.filter(function (t) {
              return t.attributes.AREA_ID === _n.attributes.AREA_ID;
            })[0];else {
              var _t = _this3.zones.filter(function (t) {
                return t.geometry.contains(s);
              });

              _r = _t.length > 0 ? v.getGraphicWithSmallestArea(_t) : null;
            }

            if (_r && I.zoneIsWholeFieldZone(_this3.entireFieldZones, _r) && A.polygonIsMultipart(_r.geometry) && _this3.recEventDetails && _this3.recEventDetails.isMultipartZoneAutoSplitAllowed() && (t(_this3, S, "m", k).call(_this3, _r, s), _r = _this3.zones.find(function (t) {
              return t.geometry.contains(s);
            })), !_r && t(_this3, S, "m", z).call(_this3, s)) {
              if (A.polygonIsMultipart(_this3.entireFieldZones[0].geometry)) {
                var _e2 = v.getSimplifiedPolygonParts(_this3.entireFieldZones[0].geometry);

                if (_e2.some(function (t) {
                  return _this3.zones.some(function (e) {
                    return i.equals(e.geometry, t);
                  });
                })) {
                  var _i = _e2.find(function (t) {
                    return t.contains(s);
                  });

                  t(_this3, S, "m", W).call(_this3, _i);
                } else t(_this3, S, "m", J).call(_this3);
              } else t(_this3, S, "m", J).call(_this3);

              _this3.resetGraphics();
            }

            _r && _this3.activateZone(_r);
          }
        });
      })), this.mapListeners.add(this.mapView.on("pointer-move", function (t) {
        var e = {
          include: [_this3.dataPointLayer, _this3.activePointsLayer]
        };

        _this3.mapView.hitTest(t, e).then(function (t) {
          _this3.mapView.container.style.cursor = t.results.length ? u.pointer : u.default;
        });
      }));
    }
  }, {
    key: "createZoneGraphic",
    value: function createZoneGraphic(t, e, i) {
      var _objectSpread2, _attributes;

      return new o(t ? {
        geometry: e,
        attributes: _objectSpread(_objectSpread({}, t.attributes), {}, (_objectSpread2 = {}, _defineProperty(_objectSpread2, q, i), _defineProperty(_objectSpread2, "CALCULATED_AREA", A.calculateArea(e)), _defineProperty(_objectSpread2, "PREV_AREA_ID", t.attributes.AREA_ID), _objectSpread2)),
        symbol: t.symbol
      } : {
        geometry: e,
        attributes: (_attributes = {}, _defineProperty(_attributes, q, i), _defineProperty(_attributes, "CALCULATED_AREA", A.calculateArea(e)), _defineProperty(_attributes, "IS_DATA", 0), _defineProperty(_attributes, "PREV_AREA_ID", i), _attributes)
      });
    }
  }, {
    key: "deleteActiveZone",
    value: function deleteActiveZone() {
      t(this, S, "m", D).call(this, this.activeZone);
    }
  }, {
    key: "getEntireFieldZones",
    value: function getEntireFieldZones() {
      var _this4 = this;

      if (!this.fieldsLayer) throw new Error("Field layer undefined");
      if (!this.fieldBoundaryGuid) throw new Error("Field Boundary undefined");
      return this.fieldsLayer.getFieldBoundaryByBoundaryGuid(this.fieldBoundaryGuid).then(function (e) {
        var _attributes2;

        var i = v.getCombinedBoundaries(e.map(function (t) {
          return t.shape;
        }));
        return [new o({
          geometry: i,
          attributes: (_attributes2 = {}, _defineProperty(_attributes2, q, t(_this4, S, "m", N).call(_this4)), _defineProperty(_attributes2, "CALCULATED_AREA", A.calculateArea(i)), _defineProperty(_attributes2, "IS_DATA", 0), _defineProperty(_attributes2, "PREV_AREA_ID", 1), _attributes2),
          symbol: b.fromJSON(h.symbols.zones.default)
        })];
      });
    }
  }, {
    key: "getMiddleLayers",
    value: function getMiddleLayers() {
      return [this.dataLayer, this.dataPointLayer, this.drawLayer];
    }
  }, {
    key: "getTools",
    value: function getTools() {
      return [m.ScoutingZoneCreate, m.ScoutingPointZoneCreate];
    }
  }, {
    key: "moveLayersToTop",
    value: function moveLayersToTop() {
      var _this5 = this;

      this.moveLayerToTop(this.activeLayer), this.getMiddleLayers().forEach(function (t) {
        return _this5.moveLayerToTop(t);
      }), this.moveLayerToTop(this.activePointsLayer);
    }
  }, {
    key: "onlyZoneIsWholeFieldZone",
    value: function onlyZoneIsWholeFieldZone() {
      return 1 === this.zones.length && I.zoneIsWholeFieldZone(this.entireFieldZones, this.zones[0]);
    }
  }, {
    key: "onlyZoneIsWholeFieldZoneAndHasNoData",
    value: function onlyZoneIsWholeFieldZoneAndHasNoData() {
      return this.onlyZoneIsWholeFieldZone() && 0 === this.zones[0].attributes.IS_DATA;
    }
  }, {
    key: "redo",
    value: function redo() {
      var _this6 = this;

      if (!this.canRedo()) return;

      var redo = function redo() {
        _this6.unSelectTools(), _this6.isUndoRedo = !0, _this6.history.redo().then(function (t) {
          _this6.activeZoneHistory.redo().then(function (e) {
            _this6.applyHistoryState(t, e), _this6.isUndoRedo = !1;
          });
        });
      };

      if (!this.polygonCreator.isActive() && !this.pointCreator.isActive()) return void redo();
      var t = this.polygonCreator.isActive() ? this.polygonCreator : this.pointCreator;
      t.history.canRedo() ? t.history.redo() : t.deactivate().then(redo);
    }
  }, {
    key: "reset",
    value: function reset() {
      return this.removeMapListeners(), this.mapView.container.style.cursor = u.default, this.labelManager.clearLabel(), this.setActiveTool(null), Promise.all([this.polygonCreator.deactivate(), this.pointCreator.deactivate()]);
    }
  }, {
    key: "resetGraphics",
    value: function resetGraphics() {
      this.activeLayer.removeAll(), this.activePointsLayer.removeAll(), this.dataLayer.removeAll(), this.dataPointLayer.removeAll(), this.drawLayer.removeAll(), this.labelManager.clearLabel();
      var e = [];

      var _iterator = _createForOfIteratorHelper(this.zones),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _i2 = _step.value;

          var _s = new o({
            attributes: _i2.attributes
          });

          if (t(this, S, "m", U).call(this, _i2)) {
            var _t2 = A.getCenterPointInPolygon(_i2.geometry);

            _s.geometry = _t2, this.dataPointLayer.add(_s);
          } else {
            var _t3 = 1 === _i2.attributes.IS_DATA ? b.fromJSON(h.symbols.zones.normal.withDataImage) : b.fromJSON(h.symbols.zones.normal.noData);

            _s.set({
              geometry: _i2.geometry,
              symbol: _t3
            }), this.dataLayer.add(_s);
          }

          e.push(_s);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return this.activeZone && t(this, S, "m", j).call(this), e;
    }
  }, {
    key: "setToolbarMenuInset",
    value: function setToolbarMenuInset(t) {
      var e = _get(_getPrototypeOf(ScoutingZoneTools.prototype), "setToolbarMenuInset", this).call(this, t);

      return this.pointCreator.setInsets(e), e;
    }
  }, {
    key: "setZoneData",
    value: function setZoneData(_ref) {
      var _this7 = this;

      var i = _ref.recEventDetails,
          s = _ref.field;
      e(this, T, !1, "f"), this.recEventDetails = i, this.field = s;
      var n = null != this.entireFieldZones && this.entireFieldZones.length > 0 && this.fieldBoundaryGuid === (i.fieldBoundaryGuid || s.fieldBoundaryGuid);
      var a = {
        areas: i.eventAreaList.map(function (t) {
          return _objectSpread(_objectSpread({}, t), {}, {
            applyToArea: t.applyEventToArea,
            areaGuid: t.eventAreaGuid,
            areaId: t.eventAreaId,
            zonePolygons: t.zonePolygons,
            classBreak: t.eventAreaClassBreak
          });
        }),
        getNewZones: r,
        guidFields: [X.agEventGeneralGuid, X.eventAreaGuid],
        generalGuids: [i.agEventGeneralGuid],
        isMerge: i.isMerge
      };
      var h = 1 === a.areas.length && null == a.areas[0].zonePolygons,
          c = h || a.areas.length >= 1 && a.areas.every(function (t) {
        t.zonePolygons && t.zonePolygons.length;
      });
      var d;
      return n || this.options.onSetToolsProcessing(!0), c || this.options.onSetMapIsLoading(!0), n ? d = Promise.resolve(this.entireFieldZones) : (this.fieldBoundaryGuid = s.fieldBoundaryGuid || i.fieldBoundaryGuid, d = this.getEntireFieldZones().then(function (t) {
        return _this7.entireFieldZones = I.cloneZones(t), t;
      }).finally(function () {
        _this7.options.onSetToolsProcessing(!1);
      })), this.reset().then(function () {
        var e;
        if (_this7.activeZone = null, _this7.updateZones([], !0, !1), h) _this7.fieldBoundaryGuid = s.fieldBoundaryGuid, e = d.then(function (t) {
          return _this7.callResetZones(t), t;
        });else if (c) console.assert(a.areas.every(function (t) {
          t.zonePolygons && t.zonePolygons.length;
        })), e = Promise.resolve(a.areas.map(function (e) {
          var i = v.getCombinedBoundaries(e.zonePolygons.map(function (t) {
            return t.shape;
          })),
              s = {
            calculatedArea: A.calculateArea(i)
          };
          return t(_this7, S, "m", B).call(_this7, new o({
            geometry: i,
            attributes: s
          }), e, a.guidFields);
        }));else {
          var _i3 = a.areas.map(function (t) {
            return t.areaGuid;
          }),
              _s2 = a.isMerge ? [] : a.generalGuids;

          e = (0, a.getNewZones)(_s2, _i3).then(function (e) {
            var i = [],
                s = e.map(l);

            var _iterator2 = _createForOfIteratorHelper(s),
                _step2;

            try {
              var _loop = function _loop() {
                var o = _step2.value;
                var e = a.areas.find(function (t) {
                  return t.areaId === o.attributes[X.eventAreaID];
                });
                o = t(_this7, S, "m", B).call(_this7, o, e, a.guidFields), i.push(o);
              };

              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                _loop();
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }

            return i;
          });
        }
        return e = e.then(function (e) {
          t(_this7, T, "f") || (e.sort(function (t, e) {
            return parseFloat(t.attributes.AREA_ID) - parseFloat(e.attributes.AREA_ID);
          }), _this7.setZones(e, !0, !c), _this7.unSelectTools());
        }), Promise.all([d, e]).then(function () {
          console.assert(1 === _this7.entireFieldZones.length), _this7.options.onSetEntireField(_this7.entireFieldZones[0].geometry);
        }).catch(function (t) {
          _this7.handleError(t);
        }).finally(function () {
          _this7.options.onSetMapIsLoading(!1);
        });
      });
    }
  }, {
    key: "setZones",
    value: function setZones(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
      this.fieldsLayer.zoomToField(this.field.fieldGuid), this.activateZone(t.find(function (t) {
        return null !== t.attributes.AREA_ID;
      }), !1), this.updateZones(t, e, i), this.resetGraphics(), this.moveLayersToTop();
    }
  }, {
    key: "toggleTool",
    value: function toggleTool(t) {
      var _this8 = this;

      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      var i = this.activeTool;
      this.reset().then(function () {
        var s = null;

        if (t.selected) {
          switch (t.index) {
            case 0:
              s = m.ScoutingZoneCreate;
              break;

            case 1:
              s = m.ScoutingPointZoneCreate;
          }

          _this8.moveLayersToTop();
        } else _this8.createMapListeners();

        i !== s ? _this8.initActivation({
          tool: s,
          activate: !0,
          byPassShare: !1,
          forceUpdate: e
        }, _this8.activateTool) : _this8.setActiveTool(i), e && _this8.forceUpdate();
      }).then(function () {
        return _this8.resetGraphics();
      });
    }
  }, {
    key: "undo",
    value: function undo() {
      var _this9 = this;

      if (!this.canUndo()) return;
      if (!this.polygonCreator.isActive() && !this.pointCreator.isActive()) return this.activeTool === m.ScoutingZoneCreate || this.activeTool === m.ScoutingPointZoneCreate ? void this.unSelectTools() : (this.isUndoRedo = !0, void this.history.undo().then(function (t) {
        _this9.activeZoneHistory.undo().then(function (e) {
          _this9.applyHistoryState(t, e), _this9.isUndoRedo = !1;
        });
      }));
      var t = this.polygonCreator.isActive() ? this.polygonCreator : this.pointCreator;
      t.history.canUndo() ? t.history.undo() : (this.unSelectTools(), t.deactivate());
    }
  }, {
    key: "unSelectTools",
    value: function unSelectTools() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      [this.zoneCreate, this.zonePointCreate].some(function (t) {
        return !!t && (t.unselect(!0), !0);
      }), this.menu && this.menu.toggleTool({
        selected: !1
      }), t ? (this.polygonCreator.isActive() && this.polygonCreator.deactivate(), this.pointCreator.isActive() && this.pointCreator.deactivate()) : this.initActivation({
        tool: null,
        activate: !1,
        byPassShare: !1,
        forceUpdate: e
      }, this.activateTool), this.createMapListeners(), this.mapView.container.style.cursor = u.default, e && this.forceUpdate();
    }
  }, {
    key: "updateAreaHasData",
    value: function updateAreaHasData(t) {
      var _this10 = this;

      if (this.isUndoRedo) return;
      var e = !1;

      var _iterator3 = _createForOfIteratorHelper(t),
          _step3;

      try {
        var _loop2 = function _loop2() {
          var _step3$value = _slicedToArray(_step3.value, 2),
              i = _step3$value[0],
              s = _step3$value[1];

          var t = _this10.dataLayer.graphics.find(function (t) {
            return t.attributes.AREA_ID === i;
          });

          t && (t.attributes.IS_DATA = s ? 1 : 0, t.symbol = s ? b.fromJSON(h.symbols.zones.normal.withDataImage) : b.fromJSON(h.symbols.zones.normal.noData), e = !0);
        };

        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          _loop2();
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      e && (this.history.setState(I.cloneZones(this.zones)), this.options.onSaveAreaList(this.field.fieldGuid, this.getRestoreId(this.history.historyIndex)));
    }
  }, {
    key: "updateZones",
    value: function updateZones(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
      var s = 0 === this.zones.length ? new Map(t.map(function (t) {
        return [t.attributes.PREV_AREA_ID, new Map()];
      })) : new Map(this.zones.map(function (t) {
        return [t.attributes.AREA_ID, new Map()];
      }));
      this.zones = t;
      var o = I.cloneZones(this.zones),
          n = this.activeZone ? this.activeZone.attributes.AREA_ID : null;
      e && this.field && this.recEventDetails && this.options.onSaveAreaList(this.field.fieldGuid, this.getRestoreId(0)), this.history.add(o, e), this.activeZoneHistory.add(n, e);
      var a = this.zones;

      if (i) {
        var _iterator4 = _createForOfIteratorHelper(this.zones),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var _t4 = _step4.value;

            var _e3 = {
              shape: _t4.geometry,
              fieldBoundaryGuid: I.zoneIsWholeFieldZone(this.entireFieldZones, _t4) ? this.field.fieldBoundaryGuid : null
            },
                _i4 = s.get(_t4.attributes.PREV_AREA_ID);

            _i4 ? _i4.set(_t4.attributes.AREA_ID, _e3) : s.set(_t4.attributes.PREV_AREA_ID, new Map([[_t4.attributes.AREA_ID, _e3]]));
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }

        this.field && (this.options.onUpdateZones(this.field.fieldGuid, s), i && this.recEventDetails && this.options.onSaveAreaList(this.field.fieldGuid, this.getRestoreId(this.history.historyIndex)));
      } else this.options.onUpdateZones(null, null, a, this.zones);

      this.forceUpdate();
    }
  }]);

  return ScoutingZoneTools;
}(E);

T = new WeakMap(), S = new WeakSet(), P = function P() {
  var t = A.getCenterPointInPolygon(this.activeZone.geometry);
  this.activePointsLayer.add(new o({
    geometry: t
  }));
}, R = function R(t) {
  var e = I.cloneZones(this.zones);
  e.push(t), this.zones = e;
  var i = this.activeZone ? this.activeZone.attributes.AREA_ID : null;
  this.history.add(e), this.activeZoneHistory.add(i), this.field && (this.options.onAddZone(this.field.fieldGuid, this.options.recsEventsModels.EVENT_TYPE_NAME_SCOUTING, t.attributes.AREA_ID, t.attributes.CALCULATED_AREA, JSON.stringify(t.geometry.toJSON())), this.recEventDetails && this.options.onSaveAreaList(this.field.fieldGuid, this.getRestoreId(this.history.historyIndex)));
}, G = function G(t) {
  if (!this.entireFieldZones) return t;
  var e = t;
  return this.entireFieldZones.some(function (s) {
    return !(i.within(t, s.geometry) || !i.intersects(t, s.geometry)) && (e = i.intersect(t, s.geometry), !0);
  }), e;
}, D = function D(t) {
  var _this11 = this;

  var e = this.zones.filter(function (e) {
    return e.attributes.AREA_ID !== t.attributes.AREA_ID;
  }).map(function (t, e) {
    return _this11.createZoneGraphic(t, t.geometry, e + 1);
  }),
      i = Math.min.apply(Math, _toConsumableArray(e.map(function (t) {
    return t.attributes.AREA_ID;
  })).concat([Number.MAX_VALUE]));
  this.activateZone(e.find(function (t) {
    return t.attributes.AREA_ID === i;
  }), !1), this.updateZones(e), this.resetGraphics(), this.moveLayersToTop();
}, _ = function _(e) {
  return !!t(this, S, "m", O).call(this) && i.within(this.entireFieldZones[0].geometry, e);
}, C = function C() {
  return !!t(this, S, "m", O).call(this) && A.polygonIsMultipart(this.entireFieldZones[0].geometry);
}, w = function w(e) {
  return t(this, S, "m", C).call(this) && e && v.getSimplifiedPolygonParts(this.entireFieldZones[0].geometry, !0).some(function (t) {
    return i.contains(e, t);
  });
}, z = function z(e) {
  return !!t(this, S, "m", O).call(this) && i.intersects(e, this.entireFieldZones[0].geometry);
}, F = function F(t) {
  return t && this.zones.some(function (e) {
    return i.equals(e.geometry, t);
  });
}, N = function N() {
  return Math.max.apply(Math, _toConsumableArray(this.zones.map(function (t) {
    return t.attributes.AREA_ID;
  })).concat([0])) + 1;
}, M = function M() {
  var _this12 = this;

  var t = this.zones.find(function (t) {
    return I.zoneIsWholeFieldZone(_this12.entireFieldZones, t);
  });
  return t ? t.attributes.AREA_ID : void 0;
}, O = function O() {
  return this.entireFieldZones && this.entireFieldZones.length > 0;
}, U = function U(t) {
  return v.calculateRawArea(t.geometry) < .00691;
}, V = function V(_ref2, n) {
  var _this13 = this;

  var e = _ref2.finished,
      o = _ref2.points;
  var a = this.options.formatMessage,
      r = this.options.messages;

  if (e) {
    var _e4 = 0;

    switch (n) {
      case d.POINT:
        var _n2 = o[0];
        if (!t(this, S, "m", z).call(this, _n2)) return void this.options.onPushToasterMessage(a(r.geometryIsOutsideFieldWarning), p.WARNING);
        {
          var _i5 = new s({
            center: _n2,
            geodesic: !0,
            radius: 2,
            radiusUnit: "meters"
          });

          if (this.onlyZoneIsWholeFieldZoneAndHasNoData()) t(this, S, "m", x).call(this, _i5, 1);else {
            _e4 = t(this, S, "m", N).call(this);

            var _s3 = this.createZoneGraphic(null, _i5, _e4);

            t(this, S, "m", R).call(this, _s3);
          }
        }
        break;

      case d.POLYGON:
        var newZonePoly = i.simplify(A.createPolygon(o));

        if (t(this, S, "m", _).call(this, newZonePoly)) {
          var _i6 = t(this, S, "m", M).call(this);

          _i6 ? _e4 = _i6 : t(this, S, "m", C).call(this) || t(this, S, "m", J).call(this);
        } else {
          if (t(this, S, "m", w).call(this, newZonePoly)) return void this.options.onPushToasterMessage(a(r.geometryContainsAFieldPartWarning), p.WARNING);
          if (!t(this, S, "m", z).call(this, newZonePoly)) return void this.options.onPushToasterMessage(a(r.geometryIsOutsideFieldWarning), p.WARNING);
          newZonePoly = t(this, S, "m", G).call(this, newZonePoly), v.getSimplifiedPolygonParts(newZonePoly, !0).forEach(function (i) {
            if (!t(_this13, S, "m", F).call(_this13, i)) if (_this13.onlyZoneIsWholeFieldZoneAndHasNoData()) t(_this13, S, "m", x).call(_this13, i, 1);else {
              _e4 = t(_this13, S, "m", N).call(_this13);

              var _s4 = _this13.createZoneGraphic(null, i, _e4);

              t(_this13, S, "m", R).call(_this13, _s4);
            }
          });
        }

    }

    this.reset().then(function () {
      _this13.unSelectTools(), _this13.resetGraphics(), _e4 > 0 && _this13.activateZone(_this13.zones.find(function (t) {
        return t.attributes.AREA_ID === _e4;
      })), _this13.options.onSetMapIsLoading(!1), _this13.forceUpdate();
    });
  }
}, B = function B(t, e, i) {
  var s = e.applyToArea,
      o = e.areaId,
      n = e.classBreak;
  return i.forEach(function (e) {
    t.attributes[e] = c(t.attributes[e]);
  }), t.attributes.CALCULATED_AREA = t.attributes.calculatedArea || e.calculatedArea, t.attributes.AREA_ID = o, t.attributes.IS_DATA = s ? 1 : 0, t.attributes.PREV_AREA_ID = o, n && (t.symbol = b.fromJSON(L.createSimpleFillSymbolJSON(n.rgbVals))), t;
}, W = function W(e) {
  var i = this.createZoneGraphic(null, e, t(this, S, "m", N).call(this));
  t(this, S, "m", R).call(this, i), this.activateZone(i), this.resetGraphics();
}, J = function J() {
  var e = t(this, S, "m", N).call(this);
  t(this, S, "m", H).call(this, e);
  var i = v.getCombinedBoundaries(this.entireFieldZones.map(function (t) {
    return t.geometry;
  })),
      s = this.createZoneGraphic(null, i, e);
  t(this, S, "m", R).call(this, s), this.activateZone(s), this.resetGraphics();
}, j = function j() {
  t(this, S, "m", U).call(this, this.activeZone) ? t(this, S, "m", P).call(this) : (this.activeLayer.add(this.activeZone), t(this, S, "m", Y).call(this, this.activeZone.geometry));
}, k = function k(t, e) {
  var i = this.zones.filter(function (e) {
    return e.attributes.AREA_ID !== t.attributes.AREA_ID;
  }),
      s = v.getSimplifiedPolygonParts(t.geometry).find(function (t) {
    return t.contains(e);
  }),
      o = this.createZoneGraphic(t, s, i.length + 1);
  i.push(o), this.updateZones(i), this.resetGraphics();
}, x = function x(t, e) {
  var i = this.entireFieldZones[0],
      s = this.createZoneGraphic(i, t, e);
  this.updateZones([s]), this.activateZone(s), this.resetGraphics();
}, H = function H(e) {
  t(this, S, "m", O).call(this) && this.entireFieldZones.forEach(function (t) {
    return t.attributes.AREA_ID = e;
  });
}, Y = function Y(t) {
  t && t.rings[0].length > 2 ? this.labelManager.updateLabel(A.getPolyLabelPoint(t), this.getAcreageText(t)) : this.labelManager.clearLabel();
};
export { ScoutingZoneTools as S };